import { Box, Typography, useTheme } from '@mui/material';

import { ImageWrapper, ReasonItemContainer, ReasonDescription } from './style';

import { NextImage } from '@components/atoms/image';
import { getAssetUrl, sanitize } from '@helpers/utils';

interface ReasonItemProps {
  imageUrl: string;
  title: string;
  description: string;
}

export const ReasonItem = ({ imageUrl, title, description }: ReasonItemProps) => {
  const theme = useTheme();

  return (
    <ReasonItemContainer>
      <ImageWrapper>
        <NextImage src={imageUrl} width={113} height={113} layout="responsive" />
      </ImageWrapper>
      <Box
        flex={1}
        textAlign={{ xs: 'left', sm: 'center' }}
        color={theme.palette.common.white}
        display="flex"
        justifyContent="space-between"
        flexDirection="column"
        sx={{ gap: '8px' }}
      >
        <Typography
          fontSize={{ xs: '18px', sm: '22px' }}
          lineHeight={{ xs: '22px', sm: '24px' }}
          fontWeight={700}
          color="#000000DE"
        >
          {title || ''}
        </Typography>
        <ReasonDescription>
          <Typography
            variant="h6_deprecated"
            fontWeight={400}
            style={{ fontFamily: theme.typography.h4lanna.fontFamily }}
            color="#00000099"
          >
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={sanitize(description)}
            />
          </Typography>
        </ReasonDescription>
      </Box>
    </ReasonItemContainer>
  );
};
